import { TemaReuniaoEnum } from 'graphql/types.generated'

export const isOnlyEducacaoPermamente = (temasReuniao: TemaReuniaoEnum[]) =>
  temasReuniao?.length === 1 && temasReuniao.includes(TemaReuniaoEnum.EDUCACAO_PERMANENTE)
